<template>
  <div v-if="options.demographics" class="container-fluid">
    <Breadcrumb :values="{ Home: '/', Search: '/search', Profile: ''}"></Breadcrumb>
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-12 contents d-flex align-items-center justify-content-end">
          <router-link :to="{name: 'study-details', params: { id: id }}" class="main-category mr-3">
            <font-awesome-icon icon="home"></font-awesome-icon>
            Concept Details
          </router-link>
          <img src="../assets/images/icons/excel-export-H.svg" class="dwn-button" @click="download()"/>
        </div>
      </div>
      <div class="card mt-2">
        <div class="card-body d-flex flex-column justify-content-center align-items-center" style="min-height: 140px"
             v-if="!noData">
          <template v-if="data.result && data.result.length">
            <div class="fragrance-header d-flex justify-content-between w-100 mb-3">
              <div>
                <div>
                  <div class="header-label">Project name:</div>
                  <span>{{parseStudyInfo(data.info.project_name)}}</span>
                </div>
                <div>
                  <div class="header-label">Client:</div>
                  <span>{{parseStudyInfo(data.info.client)}}</span>
                </div>
                <div>
                  <div class="header-label">Concept name:</div>
                  <span>{{parseStudyInfo(data.info.name)}}</span>
                </div>
              </div>
              <div>
                <div class="d-flex flex-column">
                  <span class="text-right header-label">Proj nr / Concept code</span>
                  <span class="text-right">{{parseStudyInfo(data.info.c_mi_number)}} / {{parseStudyInfo(data.info.concept_code || $route.params.code)}}</span>
                </div>
                <div class="d-flex flex-column">
                  <div class="text-right header-label">Category / Product</div>
                  <span class="text-right">{{parseStudyInfo(data.info.category)}} / {{parseStudyInfo(data.info.product)}}</span>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center w-100">
              <div class="d-flex align-items-center">
                <div>
                  <el-select
                      v-model="conceptFilters.category"
                      placeholder="Select filter" filterable
                      @change="conceptFilters.value = ''" collapse-tags
                  >
                    <el-option-group label="Press Tab/Escape to exit">
                      <el-option
                          v-for="value in filterList"
                          :key="value" :label="parseLabel(value)" :value="value">
                      </el-option>
                    </el-option-group>
                  </el-select>
                </div>
                <div v-if="conceptFilters.category" class="ml-2">
                  <el-select
                      v-model="conceptFilters.value"
                      placeholder="Select value" filterable collapse-tags
                  >
                    <el-option-group label="Press Tab/Escape to exit">
                      <el-option
                          v-for="value in this.options.demographics[conceptFilters.category]"
                          :key="typeof value === 'object' ? value.label : value"
                          :label="typeof value === 'object' ? value.label : value"
                          :value="typeof value === 'object' ? value.label : value">
                      </el-option>
                    </el-option-group>
                  </el-select>
                </div>
                <div class="search-error">{{error}}</div>
              </div>
              <div class="d-flex justify-content-center align-items-center">
                <button class="search-button btn btn-block btn-outline-danger" @click="clearFilters()">Clear</button>
                <button class="search-button btn btn-block btn-outline-primary ml-2 mt-0" @click="getData()">Filter
                </button>
              </div>
            </div>
            <div class="footnote mb-4">
              <span class="footnote-text">All scores and metrics have been harmonized to a common 5 point scale</span>
              <span v-if="showBinaryScaleInfo" class="footnote-text">*This is a CATA (dichotomous variable) harmonized to a 5 points scale, therefore there are no neutral scores".</span>
            </div>
            <el-input v-model="tableQuery" placeholder="Filter tables" clearable
                      @input="changeTableQuery" class="filter-input">
            </el-input>
            <template v-if="nonStrengthPerformanceTable.data && nonStrengthPerformanceTable.data.length">
              <h5>Performance data:</h5>
              <Table class="frag-profile-table" style="margin-bottom: 50px;" :show-download="false" ref="firstTable" :hide-filters="true"
                     :data="nonStrengthPerformanceTable.data" :columns="nonStrengthPerformanceTable.columns" :options="nonStrengthPerformanceTable.options"></Table>
            </template>
            <span v-else class="no-attributes-warning">Attributes were not detected for this specific fragrance.</span>
          </template>
        </div>
        <div class="card-body d-flex flex-column justify-content-center align-items-center" style="height: 140px"
             v-else>
          <div class="d-flex justify-content-between align-items-center w-100 mb-4">
            <div class="d-flex align-items-center">
              <div>
                <el-select
                    v-model="conceptFilters.category"
                    placeholder="Select filter" filterable collapse-tags
                    @change="conceptFilters.value = ''"
                >
                  <el-option-group label="Press Tab/Escape to exit">
                    <el-option
                        v-for="value in Object.keys(this.options.demographics)"
                        :key="value" :label="parseLabel(value)" :value="value">
                    </el-option>
                  </el-option-group>
                </el-select>
              </div>
              <div v-if="conceptFilters.category" class="ml-2">
                <el-select
                    v-model="conceptFilters.value"
                    placeholder="Select value" filterable collapse-tags
                >
                  <el-option-group label="Press Tab/Escape to exit">
                    <el-option
                        v-for="value in this.options.demographics[conceptFilters.category]"
                        :key="value" :label="value" :value="value">
                    </el-option>
                  </el-option-group>
                </el-select>
              </div>
            </div>
            <div class="d-flex justify-content-center align-items-center">
              <button class="search-button btn btn-block btn-outline-danger" @click="clearFilters()">Clear</button>
              <button class="search-button btn btn-block btn-outline-primary ml-2 mt-0" @click="getData()">Filter
              </button>
            </div>
          </div>
          <div class="footnote mb-4">
            <span class="footnote-text">All scores and metrics have been harmonized to a common 5 point scale</span>
          </div>
          <div style="min-height: 100px">
            <i>No fragrance profile data</i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import studiesActions from '../store/modules/studies/actionTypes'
import { mapActions } from 'vuex'
import generalActions from '../store/modules/general/actionTypes'
import Breadcrumb from '../components/shared/Breadcrumb'
import Table from '../components/shared/Table'
import fileNames from '../constants/fileNames'

export default {
  name: 'ConceptProfile',
  props: {
    attributes: Array
  },
  components: { Table, Breadcrumb },
  data () {
    return {
      conceptFilters: {
        category: '',
        value: ''
      },
      showBinaryScaleInfo: false,
      nonStrengthPerformanceTable: {
        columns: ['metric_type', 'metric_name', 'mean', 'top_box', 'top_2_box', 'just_right', 'bottom_box', 'bottom_2_box'],
        data: [],
        options: {
          headings: {
            'just_right': 'Neutral'
          }
        }
      },
      id: this.$route.params.id,
      options: {},
      data: [],
      filters: {},
      tableQuery: '',
      sortBy: {
        key: 'metric_type',
        desc: true
      },
      noData: false,
      error: ''
    }
  },
  computed: {
    metricList () {
      return this.data.result.map(el => el.metric)
    },
    filterList () {
      return this.options.demographics ? Object.keys(this.options.demographics).filter(el => this.data.filters.includes(el.toLowerCase()) && el !== 'bumo') : []
    },
    aggregationList () {
      if (this.data.result.length) {
        let list = Object.keys(this.data.result[0])
        list.splice(list.indexOf('metric'), 1)
        return list
      }
      return []
    },
    filteredData () {
      const arrayCopy = _.clone(this.data.result)
      const sortedArray = arrayCopy.sort((a, b) => {
        if (a[this.sortBy.key] < b[this.sortBy.key]) {
          return -1
        }
        if (a[this.sortBy.key] > b[this.sortBy.key]) {
          return 1
        }
        return 0
      })
      return this.sortBy.desc ? sortedArray : sortedArray.reverse()
    }
  },
  methods: {
    ...mapActions({
      getAnalyticsFields: studiesActions.FETCH_ANALYTICS_FIELDS,
      getProfileData: studiesActions.FETCH_CONCEPT_PROFILE,
      getXLSX: studiesActions.GET_FRAGRANCE_PROFILE_XLSX,
      toggleLoading: generalActions.TOGGLE_LOADING
    }),
    parseLabel (value) {
      const string = value.replace(/_+/g, ' ')
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    parseStudyInfo (value) {
      if (value) {
        return value === 'nan' ? '-' : value
      }
      return '-'
    },
    parseData (data, aggregationValue) {
      const value = data[aggregationValue]
      if (aggregationValue === 'is_binary_scale') {
        return value
      }
      return Object.keys(data) &&
      value
        ? ['metric_type', 'metric_name'].includes(aggregationValue)
          ? this.parseLabel(value) || '-'
          : aggregationValue === 'mean'
            ? typeof value === 'string'
              ? value
              : value.toFixed(2)
            : typeof value === 'string'
              ? value
              : Math.round(value) + '%'
        : '-'
    },
    parseTableData (data) {
      let values = _.cloneDeep(data)
      values.forEach((row, index) => {
        Object.keys(row).forEach(key => {
          values[index][key] = this.parseData(row, key)
        })
      })
      return values
    },
    changeSort (newKey) {
      if (this.sortBy.key === newKey) {
        const test = !this.sortBy.desc
        this.$set(this.sortBy, 'desc', test)
      } else {
        this.$set(this.sortBy, 'key', newKey)
        this.$set(this.sortBy, 'desc', true)
      }
    },
    getFilterData () {
      const parsedQuery = {
        demographics: []
      }
      const { category, value } = this.conceptFilters
      if (category && value) {
        parsedQuery.demographics.push(category === 'social_class' ? this.options.demographics.social_class.find(el => el.label === value).value : {
          field: category,
          filter: {
            type: 'equal',
            value: value
          }
        })
      }
      return parsedQuery
    },
    clearFilters () {
      this.conceptFilters = {
        category: '',
        value: ''
      }
    },
    setTableQueries () {
      this.$refs.firstTable.setQuery(this.tableQuery)
      this.$refs.secondTable.setQuery(this.tableQuery)
    },
    changeTableQuery () {
      this.setTableQueries()
    },
    checkAndAddMissingAttributes (data) {
      const necessaryMetrics = ['liking', 'strength', 'purchase_intention']
      const values = data.result.filter(el => necessaryMetrics.includes(el.metric))
      if (values.length < 3) {
        necessaryMetrics.forEach(metric => {
          if (!values.filter(el => el.metric === metric).length) {
            this.data.result.push({
              metric,
              metric_name: this.parseLabel(metric),
              metric_type: 'Performance',
              top_box: 'N/A',
              top_2_box: 'N/A',
              just_right: 'N/A',
              bottom_box: 'N/A',
              bottom_2_box: 'N/A',
              mean: 'N/A'
            })
          }
        })
      }
    },
    async download () {
      const response = await this.getXLSX({
        q: this.getFilterData(),
        id: this.$route.params.id,
        code: this.$route.params.code
      })
      const url = window.URL.createObjectURL(new Blob([response]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileNames.fragranceProfile)
      document.body.appendChild(link)
      link.click()
    },
    async getData () {
      this.toggleLoading(true)
      const response = await this.getProfileData({
        id: this.$route.params.id,
        code: this.$route.params.code,
        data: this.getFilterData()
      })
      if (response) {
        this.data = response
        this.noData = !this.data
        if (!this.noData) {
          this.checkAndAddMissingAttributes(this.data)
        }
        const parsedTableData = this.parseTableData(this.data.result)
        this.nonStrengthPerformanceTable.data = parsedTableData.filter(el => el.metric_type === 'Performance' && el.metric_name !== 'Strength')
        this.showBinaryScaleInfo = this.attributesTable ? this.attributesTable.data.some(el => el.is_binary_scale) : false
        this.error = ''
      } else {
        this.clearFilters()
        this.error = 'No data found for provided filters, displaying previous data.'
      }
      this.toggleLoading(false)
    }
  },
  async mounted () {
    this.options = await this.getAnalyticsFields()
    await this.getData()
  }
}
</script>

<style scoped lang="scss">
@import "../assets/scss/variables";

.card {
  background-color: rgba(255, 255, 255, 0.63);
}

.table-field {
  flex: 1;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.secondary {
  background-color: rgb(245, 247, 255);
}

.table-label {
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex: 1;
  transition: background-color 0.1s linear;
  border-bottom: 1px solid #d1d4d7;
}

.table-label:hover {
  background-color: #EEEEEE;
}

.row-label {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  border-top: 1px solid #d1d4d7;
  border-bottom: 1px solid #d1d4d7;
}

.table {
  border-top: 1px solid #d1d4d7;
}

.frag-profile-table {
  width: 80%;
}

.main-category {
  color: $magento;
  font-size: 17px;
}

.search-button {
  border-radius: 4px;
}

.footnote {
  margin-top: 10px;
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  height: unset;
}

.footnote-text {
  color: #959799;
  font-size: 16px;
}

.no-attributes-warning {
  font-size: 20px;
  color: $red-400;
  text-transform: uppercase;
}

.fragrance-header {
  font-size: 20px;
}

.header-label {
  font-size: 14px;
  color: #959799;
}

.search-error {
  font-size: 14px;
  color: #c24748;
  margin-left: 15px;
}

.excel-download-button {
  width: 240px;
  height: 48px;
  background-color: $celery-500;
  border-radius: 4px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 900;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0;
  text-transform: uppercase;
  color: white;

  transition: background-color 0.2s linear;

  &:hover {
    color: white;
    background-color: $celery-700;
  }
}
</style>
